export const notesInitialState = {
  isDrawerClicked: false,
  isGridView: true,
  sideLinkData: {
    activeLink: "",
  },
  selectedNotes: {},
  notes: [],
  trashNotes: [],
};
